export default __webpack_public_path__ + "static/media/login.d498db24.svg";